import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=69c602bc&scoped=true&"
import script from "./BasePicture.vue?vue&type=script&lang=js&"
export * from "./BasePicture.vue?vue&type=script&lang=js&"
import style0 from "./BasePicture.vue?vue&type=style&index=0&id=69c602bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c602bc",
  null
  
)

export default component.exports